import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';

import { formatDateIso } from './formatDateIso';

export function getPreviousDayIso(date: string) {
  return formatDateIso(subDays(parseISO(date), 1));
}
